<template>
    <div class="text-center">
        <template v-if="actorInfo">
            <div class="actorCard">
                <img v-bind:src="`https://image.tmdb.org/t/p/w150_and_h150_face/${actorInfo.profile_path}`" class="actorCard__photo" alt="">
                <span class="actorCard__name">{{actorInfo.name}}</span>
                <span class="actorCard__birth"><font-awesome-icon icon="map-marker-alt" /> {{actorInfo.place_of_birth}}</span>
                <div class="divider">
                    <span><font-awesome-icon icon="birthday-cake" /> {{actorInfo.birthday | friendlyDate }} <span class="spacer">-</span> {{ getCurrentAge() }} yrs</span>
                </div>
            </div>

            <div class="actorCredits">
                <table>
                    <thead>
                        <tr>
                            <th class="text-left">Title</th>
                            <th>Age</th>
                            <th v-if="showSeasons"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="role in actorCredits" :data-credit-id="role.credit_id">
                            <td class="text-left">
                                <template v-if="role.media_type === 'movie'">
                                    <font-awesome-icon icon="film" /> {{role.original_title}}
                                </template>
                                <template v-if="role.media_type === 'tv'">
                                    <font-awesome-icon icon="tv" /> {{role.original_name}}
                                </template>

                                <span v-if="role.character" class="actorCredits__character">({{role.character}}<span class="" v-if="role.episode_count > 1">- {{role.episode_count }} episodes</span>)</span>
                            </td>

                            <td>
                                {{calculateAgeFromDates(actorInfo.birthday, role.unifiedDate)}}
                            </td>
                            <template v-if="showSeasons && role.showCredits">
                                <td>
                                    <table>
                                        <tbody>
                                            <tr v-for="showCredit in role.showCredits.seasons">
                                                <template v-if="showCredit">
                                                    <td>
                                                        {{showCredit.name}}
                                                    </td>
                                                    <td>
                                                        {{showCredit.episode_count}} eps
                                                    </td>
                                                    <td>
                                                        {{showCredit.air_date}}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
</template>

<script>
    import actorCreditsA from './../actorCredits.json';
    import actorInfoA from './../actorInfo.json';
    import moment from 'moment';

    export default {
        name: 'ActorCard',
        props: ['info', 'credits', 'showSeasons'],
        data() {
            return {
                actorInfo: this.info,
                actorCredits: this.credit
            }
        },
        watch: {
            credits: function() {
                var data = this.credits;

                data = data.map( (x) => {
                    if (x.media_type  === 'tv') {
                        x.unifiedDate = moment(x.first_air_date);
                    } else if (x.media_type === 'movie') {
                        x.unifiedDate = moment(x.release_date);
                    } else {
                        return false;
                    }

                    return x;
                })

                data = data.filter( (x) => {
                    return (x.unifiedDate >= moment(this.info.birthday))
                })

                data.sort( (a, b) => ( a.unifiedDate > b.unifiedDate ? -1 : 1))

                // Ensure to update local data stores
                this.actorCredits = data;
                this.actorInfo = this.info;
            }
        },
        methods: {
            calculateAgeFromDates(first, second) {
                first = moment(first);

                if (typeof second === 'undefined')  {
                    second = moment();
                } else {
                    second = moment(second);
                }

                let age = moment.duration(second.diff(first));
                let ageYears = Math.floor(age.asYears());
                return ageYears
            },
            getCurrentAge() {
                return this.calculateAgeFromDates(this.info.birthday)
            },
        },
        filters: {
            calculateStrAge(val) {
                if (!val) return '';

                return calculateAge(val);
            },
            friendlyDate(date) {
                if (!date) return '';

                return moment(date).format('Do MMMM YYYY');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .actorCredits {
        font-family: 'Montserrat', sans-serif;

        &__character {
            font-style: italic;
        }

        table {
            background-color: white;
            border-radius: 3px;
            margin: 0 auto;
        }

        tr {
            border-bottom: 1px solid #e8e8e8;
            color: black;
            font-size: 14px;

            table tr {
                border-bottom: none;
            }
        }

        td, th {
            padding: 7px 12px;
        }

        th {
            font-weight: 500;
        }

        .svg-inline--fa {
            color: #6896cb;
            margin-right: 2px;
        }
    }
    .actorCard {
        background-color: #242e42;
        border-radius: 8px;
        display: inline-block;
        padding: 15px 20px;
        color: white;
        font-family: 'Montserrat', sans-serif;
        margin-bottom: 25px;

        .svg-inline--fa {
            color: #6896cb;
            margin-right: 2px;
        }

        &__photo {
            border-radius: 40% 40% 40% 40% / 35% 35% 35% 35%;
            border: 2px solid white;
            box-shadow: 0 0 2px 2px #00000047;
            margin: 0 auto 15px;
        }

        &__name {
            display: block;
            text-align: center;
            font-weight: 500;
            font-size: 20px;
        }

        &__birth {
            display: block;
            text-align: center;
        }

        .divider {
            border-top: 2px solid #515a6b;
            border-bottom: 2px solid #515a6b;
            padding: 7px 0;
            margin: 7px 0 10px;
            text-align: center;
            font-size: 15px;
        }

        .spacer {
            color: #515a6b;
        }
    }
</style>
